import { utils } from "@pixi/core";
import { Input, InputOptions } from "@pixi/ui";
import { Sprite } from "pixi.js";
import { ITextInput } from "./ITextInput";
import { Event } from "event-system";

export class TextInput extends Input implements ITextInput {
    public onStartEditing: Event<void>;

    private inputMode: string;

    public override set value(v: string) {
        super.value = v;
        const newBG = new Sprite((this._bg as Sprite).texture);
        newBG.width = this.inputField.width + 10;
        newBG.height = this._bg.height;
        this.bg = newBG;
        this.align();
    }
    public override get value(): string {
        return super.value;
    }

    public constructor(options: InputOptions, inputMode: string) {
        super(options);
        this.inputMode = inputMode;
        this.onStartEditing = new Event();
        this._cursor.tint = "#ffffff";
    }

    protected override _startEditing(): void {
        this.onStartEditing.emit();
        super._startEditing();
    }

    protected override createInputField(): void {
        super.createInputField();
        this.input.setAttribute("inputmode", this.inputMode);
        this.input.style.zIndex = "-1";
    }

    public manualyStartEditing(): void {
        this.activation = true;
        utils.isMobile.any && this.handleActivation();
    }
}
